<ul [id]="imageInputFlag ? 'myImageTags' : 'myTags'" (click)="customFunc($event)"
  class="tagit ui-widget ui-widget-content ui-corner-all" [ngClass]="(enableEmailValidation && invalidEmail? 'email-validation':'')">
  <ng-container *ngIf="!defaulttags">
    <div *ngIf="enableDrag && tags" [dragula]="'keywords-bag'"
        id="pin" [dragulaModel]='tags' >
    <ng-container *ngFor="let item of tags; let i = index; trackBy: trackByName">
      <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable">
        <ng-container *ngIf="isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item.name}}</span>
        </ng-container>
        <ng-container *ngIf="!isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item}}</span>
        </ng-container>
        <a class="tagit-close" *ngIf="!notRemovable">
          <span *ngIf="editFlag || !keywordDensity" class="text-icon" (click)="deleteTag(i)">×</span>
          <span class="ui-icon ui-icon-close"></span>
        </a>
        <input type="hidden" value="fsbbfb" name="tags" class="tagit-hidden-field">
      </li>
    </ng-container>
    </div>
    <ng-container *ngIf="!enableDrag">
    <ng-container *ngFor="let item of tags; let i = index; trackBy: trackByName">
      <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable">
        <ng-container *ngIf="isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item.name}}</span>
        </ng-container>
        <ng-container *ngIf="!isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item}}</span>
        </ng-container>
        <a class="tagit-close" *ngIf="!notRemovable">
          <span *ngIf="editFlag || !keywordDensity" class="text-icon" (click)="deleteTag(i)">×</span>
          <span class="ui-icon ui-icon-close"></span>
        </a>
        <input type="hidden" value="fsbbfb" name="tags" class="tagit-hidden-field">
      </li>
    </ng-container>
    </ng-container>
    <ng-container *ngIf="suggestionTags && suggestionTags !== []">
      <ng-container *ngFor="let item of suggestionTags; let i = index">
        <li class="tagit-choice suggestion">
          <span class="tagit-label" (click)="addSuggested(i)">{{item}}</span>
          <a class="tagit-close" (click)="addSuggested(i)">
            <span class="text-icon">×</span>
          </a>
        </li>
      </ng-container>
    </ng-container>
    <li class="tagit-new">
      <ng-container *ngIf="autosuggest">
        <ng-container *ngIf="!keywordDensity">
          <input type="text" class="textBox" #tagInput [disabled]="editFlag || textEditFlag" [placeholder]="textValue"
          [(ngModel)]="tagQuery" (focus)="focusIn()" [id]="inputIdValue" (focusout)="focusOut()" (keydown)="onKeydown($event)"
          (keyup)="filterAutoComplete($event)">
        </ng-container>

        <div #suggestRef>
          <div #listRef class="autosuggestion block"
            *ngIf="insideTagSuggest && (nominreq ? true : (tagQuery.trim().length > 1)) && filteredSuggestion && filteredSuggestion.length > 0">
            <ng-container *ngFor="let item of filteredSuggestion;let i = index">
              <ul>
                <li (click)="selectAutoComplete(item)" [class.active]="i === currentSelection">
                  <ng-container *ngIf="isDataKeyValuePair">
                    <span class="name">{{item.name}}</span>
                  </ng-container>
                  <ng-container *ngIf="!isDataKeyValuePair">
                    <span class="name">{{item}}</span>
                  </ng-container>
                  <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                </li>
              </ul>
            </ng-container>
          </div>
        </div>

        <ng-container
          *ngIf="insideTagSuggest && ((1 > filteredSuggestion.length)) && tagQuery !== ''">
          <div class="autosuggestion block">
            <ul>
              <li>
                <span class="name">No Results</span>
              </li>

            </ul>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!autosuggest">
        <ng-container *ngIf="!storyTags">
          <ng-container *ngIf="!keywordDensity">
            <input #input (focusout)="focusOutFn($event)" [disabled]="editFlag" type="text"
            class="textBox ui-widget-content ui-autocomplete-input" placeholder="{{textValue}}" [(ngModel)]="tag"
            (keyup)="addTag($event)" id="{{inputIdValue}}" autocomplete="off" (focus)="focusIn()">
          </ng-container>
            <p *ngIf="enableEmailValidation && invalidEmail" style="color: red; font-size: 11px;"> Enter Valid email address</p>
        </ng-container>
        <ng-container *ngIf="storyTags">
          <ng-container *ngIf="!keywordDensity">
            <input #input type="text" class="textBox ui-widget-content ui-autocomplete-input" [disabled]="editFlag"
            placeholder="{{textValue}}" id="{{inputIdValue}}" [(ngModel)]="tag" (keydown)="onKeydown($event)"
            (keyup)="filterAutoComplete($event)" (focus)="focusIn()" (focusout)="focusOutFn($event)">
          </ng-container>


          <div #suggestRef>
            <div #listRef class="autosuggestion block"
              *ngIf="insideTagSuggest && (nominreq ? true : (tag && tag.trim().length > 0)) && filteredSuggestion && filteredSuggestion.length > 0">
              <ng-container *ngFor="let item of filteredSuggestion;let i = index">
                <ul>
                  <li (click)="selectAutoComplete(item)" [class.active]="i === currentSelection">
                    <ng-container *ngIf="isDataKeyValuePair">
                      <span class="name">{{item.name}}</span>
                    </ng-container>
                    <ng-container *ngIf="!isDataKeyValuePair">
                      <span class="name">{{item}}</span>
                    </ng-container>
                    <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                  </li>
                </ul>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </li>
  </ng-container>

  <ng-container *ngIf="defaulttags">
    <ng-container *ngFor="let item of tags; let i = index; trackBy: trackByName">
      <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable">
        <ng-container *ngIf="isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item.name}}</span>
        </ng-container>
        <ng-container *ngIf="!isDataKeyValuePair">
          <span class="tagit-label" (click)="editTag(i)">{{item}}</span>
        </ng-container>
      </li>
    </ng-container>
  </ng-container>


</ul>
